import React from 'react';
import {useSelector} from 'react-redux';


import {BulkActionTool} from 'src/components/bulk-tool';
import {selectDataTableSelection} from 'src/components/data-table-selection/services/data-table-selection-slice';
import {bulkAssignUserEntitlements, getAssignUserEntitlementsProgress} from 'src/openapi/admin/apis/BulkAssignUserEntitlementsApi';
import {useAppDispatch} from 'src/store/hooks';

import Button from '@pb/kit-component-button';
import {useShown} from '@pb/kit-hooks-use-shown';

import {AssignUserEntitlementsModal} from './assign-user-entitlements.modal';
import {
    selectAssignUserEntitlementsBulkUuid,
    selectAssignUserEntitlementsTask,
    setBackgroundTask,
    setShown,
    setUuid,
} from './assign-user-entitlements.slice';
import {
    MODAL_WIDTH,
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';

import type {UpdateUserEntitlementsRelation} from 'src/openapi/admin/models/UpdateUserEntitlementsRelation';
import type {AppState} from 'src/store/typedef';

type Props = {
    userId: number,
    selectionKey: string,
    onDone: () => void,
};

export const AssignUserEntitlementsTool = ({selectionKey, onDone, userId}: Props) => {
    const apiDispatch = useAppDispatch();
    const {shown, onClick, onClose} = useShown();
    const selection = useSelector((state: AppState) => selectDataTableSelection(state, selectionKey));

    return (
        <>
            <Button disabled={!selection.ids.length} variant="Type.PRIMARY" onClick={onClick}>
                {TOOL_TITLE}
            </Button>
            <BulkActionTool<UpdateUserEntitlementsRelation>
                shown={shown}
                onClose={onClose}
                width={MODAL_WIDTH}

                toolTask={TOOL_TASK}
                toolName={TOOL_TITLE}
                progressLabel={TOOL_PROGRESS_LABEL}

                taskSelector={selectAssignUserEntitlementsTask}
                uuidSelector={selectAssignUserEntitlementsBulkUuid}

                setUuid={setUuid}
                setTask={setBackgroundTask}
                setResultShown={setShown}
                saveActionRequest={(updateUserEntitlementsRelation, options) => (
                    apiDispatch(bulkAssignUserEntitlements({...options, updateUserEntitlementsRelation}))
                )}
                getProgress={id => apiDispatch(getAssignUserEntitlementsProgress({id}))}

                stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
                onDone={onDone}>
                {({processAction, onCloseModal}) => (
                    <AssignUserEntitlementsModal
                        userId={userId}
                        ids={selection.ids}
                        onCloseModal={onCloseModal}
                        processAction={processAction}
                    />
                )}
            </BulkActionTool>
        </>
    );
};
